<template>
  <div class="cash-card">
    <div class="title">支付</div>
    <div class="content">
      <div class="row">
        <div class="label">合计费用</div>
        <div class="text cost">
          <template v-if="isChartered">{{
            (groupPrice || 0) | $$cost
          }}</template>
          <template v-else>
            {{ (cashParams ? cashParams.actualPrice || 0 : 0) | $$cost }}元
          </template>
        </div>
      </div>
      <div class="row">
        <div class="label">支付方式</div>
        <div class="text">{{ payTypeName }}</div>
      </div>
      <div v-if="showCoupon && !isChartered" class="row" @click="onChoose">
        <div class="label">优惠劵</div>
        <div v-if="!coupons || !coupons.length" class="text">
          暂无可用优惠券
        </div>
        <div
          v-else-if="
            !cashParams ||
              !cashParams.selectedCouponId ||
              cashParams.selectedCouponId === DO_NOT_USE_COUPON
          "
          class="row2"
        >
          <div class="text">不使用优惠券</div>
          <img src="../../../assets/img-v2/ic_coupon_arrow.png" class="arrow" />
        </div>
        <div v-else-if="couponTxt" class="row2">
          <div class="text coupon">{{ couponTxt }}</div>
          <img src="../../../assets/img-v2/ic_coupon_arrow.png" class="arrow" />
        </div>
      </div>
    </div>
    <div class="btn" @click="onOrder">
      确认支付&nbsp;
      <span v-if="isChartered">{{ groupPrice | $$cost }}元</span>
      <span v-else-if="actualPrice >= 0">{{ actualPrice | $$cost }}元</span>
    </div>
  </div>
</template>

<script>
import { fenToYuan, getPayType } from "../../../utils";

const DO_NOT_USE_COUPON = "no";
const TYPE = {
  MONEY: 0, // 现金券
  ACTIVITY: 1, // 活动券
};

export default {
  name: "CashCard",
  props: {
    showCoupon: {
      type: Boolean,
      default: true,
    },
    coupons: {
      type: Array,
      default() {
        return [];
      },
    },
    cashParams: {
      type: Object,
      default: () => {},
    },
    isChartered: {
      type: Boolean,
      default: false,
    },
    groupPrice: {
      type: [Number, String],
    },
  },
  data() {
    return {
      DO_NOT_USE_COUPON,
      actualPrice: 0,
      couponTxt: "",
      lock: false,
      payTypeName: getPayType().name || "微信支付",
    };
  },
  watch: {
    cashParams: {
      deep: true,
      immeate: true,
      handler() {
        this.handleCoupon();
      },
    },
  },
  filters: {
    $$cost: (val) => `${(Number(val) / 100).toFixed(2)}`,
  },
  computed: {},
  methods: {
    onChoose() {
      if (this.coupons.length) {
        this.$emit("onChoose");
      }
    },
    onOrder() {
      if (this.lock) return;
      const { selectedCouponId } = this.cashParams || {};
      this.$emit("onOrder", {
        couponId: selectedCouponId,
        actualPrice: this.actualPrice,
      });
    },
    onRetry() {
      window.location.reload();
    },
    getCouponTxt({ type, originPrice, couponPrice, couponName }) {
      if (type === TYPE.MONEY) {
        const diff = (originPrice || 0) - (couponPrice || 0);
        return diff < 0
          ? `-${fenToYuan(originPrice || 0)}元`
          : `-${fenToYuan(couponPrice)}元`;
      } else {
        return couponName || "";
      }
    },
    handleCoupon() {
      const {
        actualPrice: cost,
        selectedCouponId,
        baseLineId,
        onStopId,
        onStopName,
        offStopId,
        offStopName,
        payType,
        singalNum,
        isChartered,
      } = this.cashParams || {};
      if (cost < 0) return;
      if (!selectedCouponId || selectedCouponId === DO_NOT_USE_COUPON) {
        this.actualPrice = cost;
        this.couponTxt = "";
        return;
      }
      const [coupon] = this.coupons.filter(
        (item) => item.couponId === selectedCouponId
      );
      const { type, couponTemplateName = "" } = coupon || {};
      this.lock = true;
      this.$HomeService
        .fetchPrice({
          baseLineId,
          onStopId,
          onStopName,
          offStopId,
          offStopName,
          ticketNum: singalNum,
          userId: this.$UserService.getUserId(),
          payType: payType,
          group: isChartered,
          couponId: selectedCouponId,
        })
        .then(({ actualPrice, couponPrice }) => {
          this.actualPrice = actualPrice;
          this.couponTxt = this.getCouponTxt({
            type,
            originPrice: cost,
            couponPrice,
            couponName: couponTemplateName,
          });
          this.lock = false;
        })
        .catch((erorr) => {
          console.error("useCouponFail: ", erorr);
          this.$emit("useCouponFail");
          this.lock = false;
          if (erorr) {
            this.$cheToast({
              type: "fail",
              text: erorr.msg || erorr.errmsg || "优惠劵使用失败",
              timeout: 3000,
            }).show();
          }
        });
    },
  },
};
</script>

<style scoped lang="scss">
.cash-card {
  background: #ffffff;
  padding: 10px 20px;
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  line-height: 22px;
  text-align: left;
  font-style: normal;

  .title {
    height: 48px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .row {
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
  .row2 {
    display: flex;
    align-items: center;
  }

  .label {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 22px;
    text-align: left;
    font-style: normal;
  }

  .text {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: rgba(0, 0, 0, 0.6);
    line-height: 22px;
    text-align: right;
    font-style: normal;
  }

  .cost {
    color: #000000;
  }

  .coupon {
    color: #fe5959;
    font-weight: bold;
  }

  .arrow {
    width: 12px;
    height: 12px;
    margin-left: 4px;
  }

  .btn {
    margin-top: 16px;
    margin-bottom: 10px;
    height: 48px;
    background: linear-gradient(90deg, #00a7fd 0%, #006efa 100%);
    border-radius: 25px;
    font-family: PingFangSC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #ffffff;
    line-height: 25px;
    text-align: center;
    font-style: normal;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
